module.exports = __webpack_public_path__ + "static/img/android1.4.ad46bc56.jpg";